import { useEffect, useRef } from 'react'

export const usePrevious = (value: string | string[]) => {
  const ref = useRef<string | string[] | null>(null)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
